










































































import { NivelBonificacao } from "@/services/dashboard-vendedor.service";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ModalNiveisVendedor extends Vue {
  dialogNiveis = false;

  @Prop({ required: true }) readonly niveis!: NivelBonificacao[];
  @Prop({ default: null }) readonly nivelAtual!: string | null;

  isNivelAtual(nomeNivel: string): boolean {
    if (!this.nivelAtual) {
      return false;
    }

    return nomeNivel === this.nivelAtual;
  }

  formatCurrency(value: number): string {
    return value.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  }
}
